import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_COLOR, ICON_HEIGHT_20 } from '../../Icon'

import { QA_NAME_GRETA_AI_CHAT_SCROLL_TO_BOTTOM } from './GretaAIChatScrollToBottomButton.constants'

import * as styles from './GretaAIChatScrollToBottomButton.module.css'

import ChevronDownIcon from '../../../icons/chevrons/down.svg'

function GretaAIChatScrollToBottomButton({ isShown, onClick }) {
  const { t } = useTranslation()

  return (
    <Button.Icon
      Icon={ChevronDownIcon}
      beforeIconProps={{
        color: ICON_COLOR.CurrentColor,
        height: ICON_HEIGHT_20,
      }}
      className={classNames(styles.button, { [styles.hidden]: !isShown })}
      height={BUTTON_HEIGHT_32}
      qaName={QA_NAME_GRETA_AI_CHAT_SCROLL_TO_BOTTOM}
      tooltip={t('Greta.ScrollToBottomKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={onClick}
    />
  )
}

export default GretaAIChatScrollToBottomButton
